import gql from 'graphql-tag';
import { placeCameraFragment } from './fragments';

export const placeAvailablePorterVideoCameras = gql`
  query placeAvailablePorterVideoCameras($placeId: ID!, $condominiumId: ID!) {
    placeAvailablePorterVideoCameras(
      placeId: $placeId
      condominiumId: $condominiumId
    ) {
      ...placeCameraParts
    }
  }
  ${placeCameraFragment}
`;

export const placeAvailableTowerCameras = gql`
  query placeAvailableTowerCameras($placeId: ID!, $condominiumId: ID!) {
    placeAvailableTowerCameras(
      placeId: $placeId
      condominiumId: $condominiumId
    ) {
      ...placeCameraParts
    }
  }
  ${placeCameraFragment}
`;

export const placeAvailableDigifortCameras = gql`
  query placeAvailableDigifortCameras($placeId: ID!, $condominiumId: ID!) {
    placeAvailableDigifortCameras(
      placeId: $placeId
      condominiumId: $condominiumId
    ) {
      ...placeCameraParts
    }
  }
  ${placeCameraFragment}
`;

export const placeAddedCameras = gql`
  query placeAddedCameras($placeId: ID!, $condominiumId: ID!) {
    placeAddedCameras(placeId: $placeId, condominiumId: $condominiumId) {
      ...placeCameraParts
    }
  }
  ${placeCameraFragment}
`;

export const condominiumDigifortCameras = gql`
  query condominiumDigifortCameras($condominiumId: ID!) {
    condominiumDigifortCameras(condominiumId: $condominiumId) {
      ...placeCameraParts
    }
  }
  ${placeCameraFragment}
`;
